export default __webpack_public_path__ + "static/media/13.aeb48ada.JPG";